import ajax from '@utils/ajax';

export const postAnswer = async (payload) =>
  await ajax('POST', '/capsiminbox/webapp/answer', JSON.stringify(payload));

export const clearAnswer = async (payload) =>
  await ajax('POST', '/capsiminbox/webapp/delete', JSON.stringify(payload));

export const postLegacyWrittenAnswer = async (payload) =>
  await ajax('POST', '/capsiminbox/webapp/written', JSON.stringify(payload));
